import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'

import { AppRoutes, ErrorBoundary } from './router'
import ToastHost from './components/ToastHost'
import { i18n } from './i18n'
import './styles/app.css'
import './styles/tokens.scss'
import './styles/global.scss'

void i18n

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AppRoutes />
        <ToastHost />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
)
